import { NgModule } from '@angular/core';
import { Routes, RouterModule, UrlSegment } from '@angular/router';
import { RealizarConsultaComponent } from './app-views/consulta/realizar-consulta/realizar-consulta.component';
import { ListConsultaCompostaComponent } from './app-views/consulta/list-consulta-composta/list-consulta-composta.component';
import { FormConsultaCompostaComponent } from './app-views/consulta/form-consulta-composta/form-consulta-composta.component';
import { ListHistoricoConsultaComponent } from './app-views/consulta/list-historico-consulta/list-historico-consulta.component';
import { LoginComponent } from './app-views/login/login.component';
import { RecuperarSenhaComponent } from './app-views/login/recuperar-senha/recuperar-senha.component';
import { ResgateConsultaComponent } from './app-views/consulta/resgate-consulta/resgate-consulta.component';
import { FormUnidadeComponent } from './app-views/unidade/form-unidade/form-unidade.component';
import { ListUnidadeComponent } from './app-views/unidade/list-unidade/list-unidade.component';
import { ListUsuarioComponent } from './app-views/usuario/list-usuario/list-usuario.component';
import { FormUsuarioComponent } from './app-views/usuario/form-usuario/form-usuario.component';
import { FormNovaSenhaComponent } from './app-views/usuario/form-nova-senha/form-nova-senha.component';
import { ListTipoUnidadeComponent } from './app-views/unidade/list-tipo-unidade/list-tipo-unidade.component';
import { FormTipoUnidadeComponent } from './app-views/unidade/form-tipo-unidade/form-tipo-unidade.component';
import { ConsultaResultadoComponent } from './app-views/consulta-resultado/consulta-resultado.component';
import { RelatorioProducaoComponent } from './app-views/relatorio/relatorio-producao/relatorio-producao.component';
import { RelatorioWebSocketComponent } from './app-views/relatorio/relatorio-web-socket/relatorio-web-socket.component';
import { RelatorioConsultasRealizadasComponent } from './app-views/relatorio/relatorio-consultas-realizadas/relatorio-consultas-realizadas.component';
import { UploadLaudoComponent } from './app-views/laudo-carsys/upload-laudo/upload-laudo.component';
import { ListLaudoCarsysComponent } from './app-views/laudo-carsys/list-laudo-carsys/list-laudo-carsys.component';
import { FormTabelaPrecoComponent } from './app-views/tabela-preco/form-tabela-preco/form-tabela-preco.component';
import { ListTabelaPrecoComponent } from './app-views/tabela-preco/list-tabela-preco/list-tabela-preco.component';
import { ListTabelaPrecoLaudoComponent } from './app-views/tabela-preco/list-tabela-preco-laudo/list-tabela-preco-laudo.component';
import { FormTabelaPrecoLaudoComponent } from './app-views/tabela-preco/form-tabela-preco-laudo/form-tabela-preco-laudo.component';
import { ListConsultaLoteComponent } from './app-views/consulta/list-consulta-lote/list-consulta-lote.component';
import { FormConsultaLoteComponent } from './app-views/consulta/form-consulta-lote/form-consulta-lote.component';
import { VisualizarConsultaLoteComponent } from './app-views/consulta/visualizar-consulta-lote/visualizar-consulta-lote.component';
import { FormLaudoComponent } from './app-views/laudo-union/form-laudo/form-laudo.component';
import { ListLaudoUnionComponent } from './app-views/laudo-union/list-laudo-union/list-laudo-union.component';
import { ListConfigLaudoUnionComponent } from './app-views/laudo-union/list-config-laudo-union/list-config-laudo-union.component';
import { FormConfigLaudoUnionComponent } from './app-views/laudo-union/form-config-laudo-union/form-config-laudo-union.component';
import { ListLaudosAgendadosComponent } from './app-views/laudo-union/list-laudos-agendados/list-laudos-agendados.component';
import { FormAgendamentoLaudoUnionComponent } from './app-views/laudo-union/form-agendamento-laudo-union/form-agendamento-laudo-union.component';
import { ListUnidadesAuditadasComponent } from './app-views/auditoria/list-unidades-auditadas/list-unidades-auditadas.component';
import { ListNovaAssociacaoAuditoraComponent } from './app-views/auditoria/list-nova-associacao-auditora/list-nova-associacao-auditora.component';
import { AuditarLaudoAuditoriaComponent } from './app-views/auditoria/auditar-laudo-auditoria/auditar-laudo-auditoria.component';
import { AuthGuardService } from './services/auth-guard-service';
import { ErroComponent } from './app-views/errors/erro/erro.component';
import { FormNovoLaudoComponent } from './app-views/laudo-union/form-laudo/form-novo-laudo/form-novo-laudo.component';
import { RelatorioLaudoComponent } from './app-views/laudo-union/relatorio-laudo/relatorio-laudo.component';
import { ListNovaAssociacaoAuditorComponent } from './app-views/auditoria/auditor/list-nova-associacao-auditor/list-nova-associacao-auditor.component';
import { ListUnidadesAtendidasComponent } from './app-views/unidade/list-unidades-atendidas/list-unidades-atendidas.component';
import { ListPontoAtendimentoComponent } from './app-views/unidade/list-ponto-atendimento/list-ponto-atendimento.component';

import { ListaConsultasCiacComponent } from './app-views/ciac/consultas/lista-consultas-ciac/lista-consultas-ciac.component';
import { FormConsultasCiacComponent } from './app-views/ciac/consultas/form-consultas-ciac/form-consultas-ciac.component';
import { DcsComponent } from './app-views/ciac/consultas/dcs/dcs.component';
import { ListaFornecedoresCiacComponent } from './app-views/ciac/fornecedores/lista-fornecedores-ciac/lista-fornecedores-ciac.component';
import { FormFornecedoresCiacComponent } from './app-views/ciac/fornecedores/form-fornecedores-ciac/form-fornecedores-ciac.component';
import { ListaConsultasFornecedoresComponent } from './app-views/ciac/consultas-fornecedores/lista-consultas-fornecedores/lista-consultas-fornecedores.component';
import { FormConsultasFornecedoresComponent } from './app-views/ciac/consultas-fornecedores/form-consultas-fornecedores/form-consultas-fornecedores.component';
import { ListaConversoesComponent } from './app-views/ciac/conversoes/lista-conversoes/lista-conversoes.component';
import { FormConversoesComponent } from './app-views/ciac/conversoes/form-conversoes/form-conversoes.component';
import { ConsultaResultadoCiacComponent } from './app-views/ciac/consulta-resultado-ciac/consulta-resultado-ciac.component';
import { DceComponent } from './app-views/ciac/consultas-fornecedores/dce/dce.component';

import { FaturamentoComponent } from './app-views/faturamento/faturamento.component';
import { FaturamentoDetalhamentoComponent } from './app-views/faturamento-detalhamento/faturamento-detalhamento.component';
import { FaturamentoDetalhamentoClienteComponent } from './app-views/faturamento-detalhamento-cliente/faturamento-detalhamento-cliente.component';
// import { ServicosComponent } from './app-views/servicos/servicos.component';

import { MeuFaturamentoComponent } from './app-views/faturamento/meu-faturamento/meu-faturamento.component';
import { Erro401Component } from './app-views/errors/erro-401/erro-401.component';
import { HomeViewComponent } from './app-views/landing-page/home-view/home-view.component';
import { InstitucionalViewComponent } from './app-views/landing-page/institucional-view/institucional-view.component';
import { AreasDeAtuacaoComponent } from './app-views/landing-page/areas-de-atuacao/areas-de-atuacao.component';
import { SolucoesComponent } from './app-views/landing-page/solucoes/solucoes.component';
import { UnidadesComponent } from './app-views/landing-page/unidades/unidades.component';
import { BlogComponent } from './app-views/landing-page/blog/blog.component';
import { ContatoComponent } from './app-views/landing-page/contato/contato.component';
import { CanetaComponent } from './app-views/landing-page/solucoes/caneta/caneta.component';
import { ConsultaComponent } from './app-views/landing-page/solucoes/consulta/consulta.component';
import { CreditoComponent } from './app-views/landing-page/solucoes/credito/credito.component';
import { DecisaoCertaComponent } from './app-views/landing-page/solucoes/decisao-certa/decisao-certa.component';
import { EcvsComponent } from './app-views/landing-page/solucoes/ecvs/ecvs.component';
import { GestaoComponent } from './app-views/landing-page/solucoes/gestao/gestao.component';
import { VistoriaAutonomaComponent } from './app-views/landing-page/solucoes/vistoria-autonoma/vistoria-autonoma.component';
import { VistoriaCautelarComponent } from './app-views/landing-page/solucoes/vistoria-cautelar/vistoria-cautelar.component';
import { VistoriaVeicularComponent } from './app-views/landing-page/solucoes/vistoria-veicular/vistoria-veicular.component';
import { UniversidadeDoCarroComponent } from './app-views/landing-page/solucoes/universidade-do-carro/universidade-do-carro.component';
import { CompraComponent } from './app-views/landing-page/solucoes/caneta/compra/compra.component';
import { ConsultaVeicularComponent } from './app-views/landing-page/solucoes/consulta/consulta-veicular/consulta-veicular.component';
import { PostViewComponent } from './app-views/landing-page/blog/post-view/post-view.component';
import { ExemploDecisaoCertaComponent } from './app-views/landing-page/solucoes/decisao-certa/exemplo-decisao-certa/exemplo-decisao-certa.component';
import { ExemploVistoriaCautelarComponent } from './app-views/landing-page/solucoes/vistoria-cautelar/exemplo-vistoria-cautelar/exemplo-vistoria-cautelar.component';
import { PoliticasDePrivacidadeComponent } from './landing-footer/politicas-de-privacidade/politicas-de-privacidade.component';
import { ConfirmarEmailComponent } from './app-views/usuario/confirmar-email/confirmar-email.component';
import { AutorizarDispositivoComponent } from './app-views/usuario/autorizar-dispositivo/autorizar-dispositivo.component';
import { PoliticasDeCookiesComponent } from './landing-footer/politicas-de-cookies/politicas-de-cookies.component';
import { ExemploVistoriaAutonomaComponent } from './app-views/landing-page/solucoes/vistoria-autonoma/exemplo-vistoria-autonoma/exemplo-vistoria-autonoma.component';


const routes: Routes = [

  //Lading page routes
  {
    path: '', component: HomeViewComponent,
    data: {
      title: 'Home',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'institucional', component: InstitucionalViewComponent,
    data: {
      title: 'INSTITUCIONAL',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'areas-de-atuacao', component: AreasDeAtuacaoComponent,
    data: {
      title: 'ÁREAS DE ATUAÇÃO',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'solucoes', component: SolucoesComponent,
    data: {
      title: 'SOLUÇÕES',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'solucao/caneta-de-avaliacao-de-pintura-2', component: CanetaComponent,
    data: {
      title: 'SOLUÇÕES',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'compra', component: CompraComponent,
    data: {
      title: 'SOLUÇÕES',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'solucao/consulta-veicular', component: ConsultaComponent,
    data: {
      title: 'SOLUÇÕES',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'consulta-veicular', component: ConsultaVeicularComponent,
    data: {
      title: 'SOLUÇÕES',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'decisao-certa', component: ExemploDecisaoCertaComponent,
    data: {
      title: 'SOLUÇÕES',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'vistoria-cautelar', component: ExemploVistoriaCautelarComponent,
    data: {
      title: 'SOLUÇÕES',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'vistoria-autonoma', component: ExemploVistoriaAutonomaComponent,
    data: {
      title: 'SOLUÇÕES',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'solucao/consulta-de-analise-de-credito', component: CreditoComponent,
    data: {
      title: 'SOLUÇÕES',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'solucao/decisao-certa', component: DecisaoCertaComponent,
    data: {
      title: 'SOLUÇÕES',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'solucao/ecvs', component: EcvsComponent,
    data: {
      title: 'SOLUÇÕES',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'solucao/gestao-de-entrada-de-seminovos', component: GestaoComponent,
    data: {
      title: 'SOLUÇÕES',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'solucao/vistoria-autonoma', component: VistoriaAutonomaComponent,
    data: {
      title: 'SOLUÇÕES',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'solucao/vistoria-cautelar', component: VistoriaCautelarComponent,
    data: {
      title: 'SOLUÇÕES',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'solucao/vistoria-veicular', component: VistoriaVeicularComponent,
    data: {
      title: 'SOLUÇÕES',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'solucao/universidade-do-carro', component: UniversidadeDoCarroComponent,
    data: {
      title: 'SOLUÇÕES',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'unidades', component: UnidadesComponent,
    data: {
      title: 'NOSSA REDE',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'blog', component: BlogComponent,
    data: {
      title: 'Blog',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'blog/:id/:slug', component: PostViewComponent,
    data: {
      title: 'Blog',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'blog/:categoriaSlug', component: BlogComponent,
    data: {
      title: 'Blog',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'contato', component: ContatoComponent,
    data: {
      title: 'Contato',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'politicas-de-privacidade', component: PoliticasDePrivacidadeComponent,
    data: {
      title: 'Política de Privacidade',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  {
    path: 'politicas-de-cookies', component: PoliticasDeCookiesComponent,
    data: {
      title: 'Política de Cookies',
      logout: false,
      permissao: '',
      isLandingPage: true,
      hideNavigation: true,
    }
  },
  // Fim lading page routes

  {
    canActivate: [AuthGuardService],
    path: 'login', component: LoginComponent,
    data: {
      title: 'Login',
      hideNavigation: true,
      logout: false,
      permissao: ''
    }
  },
  {
    path: 'logout', component: LoginComponent,
    data: {
      title: 'Login',
      hideNavigation: true,
      logout: true,
      permissao: ''
    }
  },
  {
    path: 'recuperar-senha', component: RecuperarSenhaComponent,
    data: {
      title: 'Recuperar Senha', hideNavigation: true, permissao: ''
    }
  },
  { path: 'confirmar-email', component: ConfirmarEmailComponent,
    data: {
      title: 'Confirmação de email', hideNavigation: true, permissao: ''
    }
   },
   { path: 'autorizar-dispositivo', component: AutorizarDispositivoComponent,
    data: {
      title: 'Autorizar de Dispositivo Novo', hideNavigation: true, permissao: ''
    }
   },
  {
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    path: 'consulta',
    data: { menu: { label: 'Consulta', icon: '' } },
    children: [
      { path: '', redirectTo: 'realizar', pathMatch: 'prefix' },
      {
        path: 'realizar', component: RealizarConsultaComponent,
        data: {
          permissao: 'consulta_alterar',
          title: 'Realizar consulta',
          menuItem: { label: 'Realizar consulta', icon: 'mdi-database-search' }
        }
      },
      {
        path: 'composta/listar', component: ListConsultaCompostaComponent,
        data: {
          permissao: 'consulta_visualizar',
          title: 'Listar consulta composta',
          menuItem: { label: 'Consulta composta', icon: 'mdi-format-list-bulleted' },
          combinada: false
        }
      },
      {
        path: 'composta/adicionar', component: FormConsultaCompostaComponent,
        data: {
          permissao: 'consulta_alterar',
          title: 'Adicionar consulta composta',
          // menuItem: { label: 'Consulta composta', icon: 'mdi-plus-circle-outline' },
          combinada: false
        }
      },
      {
        path: 'composta/editar/:uuid', component: FormConsultaCompostaComponent,
        data: {
          permissao: 'consulta_alterar',
          title: 'Editar consulta composta',
          combinada: false,
        }
      },
      {
        path: 'combinada/listar', component: ListConsultaCompostaComponent,
        data: {
          permissao: 'consulta_visualizar',
          title: 'Listar consulta combinada',
          menuItem: { label: 'Consulta combinada', icon: 'mdi-format-list-bulleted' },
          combinada: true,
        }
      },
      {
        path: 'combinada/adicionar', component: FormConsultaCompostaComponent,
        data: {
          permissao: 'consulta_alterar',
          title: 'Adicionar consulta combinada',
          // menuItem: { label: 'Consulta combinada', icon: 'mdi-plus-circle-outline' },
          combinada: true,
        }
      },
      {
        path: 'combinada/editar/:uuid', component: FormConsultaCompostaComponent,
        data: {
          permissao: 'consulta_alterar',
          title: 'Editar consulta combinada',
          combinada: true,
        }
      },
      {
        path: 'historico', component: ListHistoricoConsultaComponent,
        data: {
          permissao: 'consulta_visualizar',
          title: 'Histórico de consultas',
          menuItem: { label: 'Histórico de consultas', icon: 'mdi-calendar-multiselect' },
          geral: false
        }
      },
      {
        path: 'historico-geral', component: ListHistoricoConsultaComponent,
        data: {
          permissao: 'historicogeral_visualizar',
          title: 'Histórico geral de consultas',
          menuItem: { label: 'Histórico geral de consultas', icon: 'mdi-calendar-multiselect' },
          geral: true
        }
      },
      {
        path: 'resgatar', component: ResgateConsultaComponent,
        data: {
          permissao: 'resgate_visualizar',
          title: 'Resgate de consultas',
          menuItem: { label: 'Resgate de consultas', icon: 'mdi-update' }
        }
      },
      {
        path: 'lote/realizar', component: FormConsultaLoteComponent,
        data: {
          permissao: 'consultalote_visualizar',
          title: 'Realizar consulta em lote',
          // menuItem: { label: 'Realizar consulta em lote', icon: 'mdi-database-search' }
        }
      },
      {
        path: 'lote/listar', component: ListConsultaLoteComponent,
        data: {
          permissao: 'consultalote_visualizar',
          title: 'Consultas em lote',
          menuItem: { label: 'Consultas em lote', icon: 'mdi-format-list-bulleted' },
        }
      },
      {
        path: 'lote/resultado/:id', component: VisualizarConsultaLoteComponent,
        data: {
          permissao: 'consultalote_visualizar',
          title: 'Resultado consulta em lote'
        }
      },
      {
        path: 'resultado/:token', component: ConsultaResultadoComponent,
        data: {
          permissao: '',
          title: 'Resultado consulta',
          cliente: false,
        }
      },
      {
        path: 'resultado-cliente/:token', component: ConsultaResultadoComponent,
        data: {
          title: 'Resultado consulta',
          cliente: true,
        }
      },
    ]
  },
  {
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    path: 'unidade',
    data: { menu: { label: 'Unidade', icon: '' } },
    children: [
      { path: '', redirectTo: 'listar', pathMatch: 'prefix' },
      {
        path: 'adicionar', component: FormUnidadeComponent,
        data: {
          permissao: 'unidade_visualizar',
          title: 'Adicionar unidade',
          // menuItem: { label: 'Adicionar unidade', icon: 'mdi-plus-circle-outline' },
        }
      },
      {
        path: 'visualizar/:id', component: FormUnidadeComponent,
        data: {
          permissao: 'unidade_visualizar',
          title: 'Visualizar unidade',
          desativarInputsEBotoes: true
        }
      },
      {
        path: 'editar/:id', component: FormUnidadeComponent,
        data: {
          permissao: 'unidade_visualizar',
          title: 'Editar unidade'
        }
      },
      {
        path: 'listar', component: ListUnidadeComponent,
        data: {
          permissao: 'unidade_visualizar',
          title: 'Listar unidades',
          menuItem: { label: 'Listar unidades', icon: 'mdi-format-list-bulleted' },
        }
      },
      {
        path: 'consulta-composta/listar', component: ListConsultaCompostaComponent,
        data: {
          permissao: 'unidade_visualizar',
          title: 'Listar consulta composta (unidade)',
          menuItem: { label: 'Consulta composta', icon: 'mdi-format-list-bulleted' },
          combinada: false, unidade: true
        }
      },
      {
        path: 'consulta-composta/adicionar/:idUnidade', component: FormConsultaCompostaComponent,
        data: {
          permissao: 'unidade_visualizar',
          title: 'Adicionar consulta composta (unidade)',
          //menuItem: { label: 'Adicionar consulta composta', icon: 'mdi-plus-circle-outline' },
          combinada: false, unidade: true
        }
      },
      {
        path: 'consulta-composta/editar/:idUnidade/:uuid', component: FormConsultaCompostaComponent,
        data: {
          permissao: 'unidade_visualizar',
          title: 'Alterar consulta composta (unidade)',
          combinada: false, unidade: true
        }
      },
      {
        path: 'tipo/listar', component: ListTipoUnidadeComponent,
        data: {
          permissao: 'unidade_visualizar',
          title: 'Listar tipos de unidades',
          menuItem: { label: 'Tipos de unidades', icon: 'mdi-format-list-bulleted' },
        }
      },
      {
        path: 'tipo/adicionar', component: FormTipoUnidadeComponent,
        data: {
          permissao: 'unidade_visualizar',
          title: 'Adicionar tipo de unidade',
          //menuItem: { label: 'Adicionar Tipo de Unidade',  icon: 'mdi-plus-circle-outline' },
        }
      },
      {
        path: 'tipo/editar/:id', component: FormTipoUnidadeComponent,
        data: {
          permissao: 'unidade_visualizar',
          title: 'Editar tipo de unidade'
        }
      },
      {
        path: 'usuario/listar', component: ListUsuarioComponent,
        data: {
          permissao: 'unidade_visualizar',
          title: 'Listar usuários (unidade)',
          menuItem: { label: 'Listar usuários', icon: 'mdi-format-list-bulleted' },
          unidade: true
        }
      },
      {
        path: 'usuario/editar/:uuid/:uuidUnidade', component: FormUsuarioComponent,
        data: {
          permissao: 'unidade_visualizar',
          title: 'Editar usuário (unidade)',
          unidade: true
        }
      },
      {
        path: 'usuario/visualizar/:uuid/:uuidUnidade', component: FormUsuarioComponent,
        data: {
          permissao: 'unidade_visualizar',
          title: 'Editar usuário (unidade)',
          unidade: true,
          desativarInputsEBotoes: true
        }
      },
      {
        path: 'usuario/adicionar/:uuidUnidade', component: FormUsuarioComponent,
        data: {
          permissao: 'unidade_visualizar',
          title: 'Adicionar usuário (unidade)',
          // menuItem: { label: 'Adicionar usuário',  icon: 'mdi-plus-circle-outline' },
          unidade: true
        }
      },
      {
        path: 'usuario/adicionar', component: FormUsuarioComponent,
        data: {
          permissao: 'unidade_visualizar',
          title: 'Adicionar usuário',
          //menuItem: { label: 'Adicionar usuário',  icon: 'mdi-plus-circle-outline' },
          unidade: true
        }
      },
      {
        path: 'usuario/alterar-minha-senha', component: FormNovaSenhaComponent,
        data: {
          title: 'Alterar senha'
        }
      },
      /*{
        path: 'usuario/alterar-senha/:id', component: FormNovaSenhaComponent,
        data: {
          permissao: 'unidade_visualizar',
          title: 'Alterar senha'
        }
      },*/
      {
        path: 'ponto-atendimento', component: ListPontoAtendimentoComponent,
        data: {
          permissao: 'unidade_visualizar',
          title: 'Pontos de atendimento',
          menuItem: { label: 'Pontos de atendimento', icon: 'mdi-format-list-bulleted' },
          unidade: true
        }
      },
      {
        path: 'unidades-atendidas', component: ListUnidadesAtendidasComponent,
        data: {
          permissao: 'unidade_visualizar',
          title: 'Unidades atendidas',
          menuItem: { label: 'Unidades atendidas', icon: 'mdi-format-list-bulleted' },
          unidade: true
        }
      },


    ]
  },
  {
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    path: 'usuario',
    data: { menu: { label: 'Usuário', icon: '' } },
    children: [
      { path: '', redirectTo: 'listar', pathMatch: 'prefix' },
      {
        path: 'listar', component: ListUsuarioComponent,
        data: {
          permissao: 'usuario_visualizar',
          title: 'Listar usuários',
          menuItem: { label: 'Listar usuários', icon: 'mdi-format-list-bulleted' },
        }
      },
      {
        path: 'visualizar/:uuid', component: FormUsuarioComponent,
        data: {
          permissao: 'usuario_visualizar',
          title: 'Visualizar usuário',
          desativarInputsEBotoes: true
        }
      },
      {
        path: 'adicionar', component: FormUsuarioComponent,
        data: {
          permissao: 'usuario_visualizar',
          title: 'Adicionar usuário',
          // menuItem: { label: 'Adicionar usuário', icon: 'mdi-plus-circle-outline' },
        }
      },
      {
        path: 'editar/:uuid', component: FormUsuarioComponent,
        data: {
          permissao: 'usuario_visualizar',
          title: 'Editar usuário'
        }
      },
     /* {
        path: 'alterar-senha/:id', component: FormNovaSenhaComponent,
        data: {
          permissao: 'usuario_visualizar',
          title: 'Alterar senha'
        }
      },*/
    ]
  },

  //relatorios
  {
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    path: 'relatorio',
    data: { menu: { label: 'Relatório', icon: '' } },
    children: [
      { path: '', redirectTo: 'meu', pathMatch: 'prefix' },
      {
        path: 'meu', component: RelatorioConsultasRealizadasComponent,
        data: {
          permissao: 'relatorio_visualizar',
          title: 'Relatório - Meu relatório',
          menuItem: { label: 'Meu relatório', icon: 'mdi-file-table-outline' },
          tipoRelatorio: 'minha-unidade'
        }
      },
      {
        path: 'unidades', component: RelatorioConsultasRealizadasComponent,
        data: {
          permissao: 'relatorio_visualizar',
          title: 'Relatório - Unidades', tipoRelatorio: 'unidades',
          menuItem: { label: 'Unidades', icon: 'mdi-file-table-outline' }
        }
      },
      {
        path: 'unidades-diretas', component: RelatorioConsultasRealizadasComponent,
        data: {
          permissao: 'relatorio_visualizar',
          title: 'Relatório - Unidades diretas',
          menuItem: { label: 'Unidades diretas', icon: 'mdi-file-table-outline' },
          tipoRelatorio: 'unidades-diretas'
        }
      },
      {
        path: 'producao', component: RelatorioProducaoComponent,
        data: {
          permissao: 'relatorio_visualizar_producao',
          title: 'Relatório de produção',
          menuItem: { label: 'Produção', icon: 'mdi-file-table-outline' },
        }
      },
      {
        path: 'consultas-clientes', component: RelatorioWebSocketComponent,
        data: {
          permissao: 'relatorio_visualizar',
          title: 'Download - Relatório de consultas de clientes',
          menuItem: { label: 'Consultas clientes', icon: 'mdi-file-download-outline' },
          tipoRelatorio: 'consultas-clientes',
          filtros: {
            dataInicio: true,
            dataFim: true, tipoCliente: true, cliente: true
          }
        }
      },
      {
        path: 'faturamento', component: RelatorioWebSocketComponent,
        data: {
          permissao: 'relatorio_visualizar_faturamento',
          title: 'Download - Relatório de faturamento',
          menuItem: { label: 'Faturamento', icon: 'mdi-file-download-outline' },
          tipoRelatorio: 'faturamento',
          filtros: {
            dataInicio: true,
            dataFim: true,
            tipoCliente: false,
            cliente: false
          }
        }
      },
    ]
  },


  //laudo
  {
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    path: 'laudo',
    data: { menu: { label: 'Laudo', icon: '' } },
    children: [
      { path: '', redirectTo: 'listar', pathMatch: 'prefix' },
      {
        path: 'adicionar', component: FormNovoLaudoComponent,
        data: {
          permissao: 'usuario_analista',
          title: 'Novo laudo',
          menuItem: { label: 'Novo laudo', icon: 'mdi-plus-circle-outline' },
        }
      },
      {
        path: 'visualizar/:id', component: RelatorioLaudoComponent,
        data: {
          permissao: null,
          title: 'Visualizar laudo',
          //menuItem: { label: 'Novo laudo', icon: 'mdi-plus-circle-outline' },
        }
      },
      {
        path: 'adicionar/:id/:step', component: FormLaudoComponent,
        data: {
          stepComplete: true,
          permissao: 'usuario_analista',
          title: 'Laudo',
          // menuItem: { label: 'Novo laudo', icon: 'mdi-plus-circle-outline' },
        }
      },
      {
        path: 'editar/:id/:step', component: FormLaudoComponent,
        data: {
          editar: true,
          permissao: 'usuario_analista',
          title: 'Laudo',
          // menuItem: { label: 'Novo laudo', icon: 'mdi-plus-circle-outline' },
        }
      },
      {
        path: 'listar', component: ListLaudoUnionComponent,
        data: {
          permissao: 'laudo_visualizar',
          title: 'Listar laudos',
          menuItem: { label: 'Listar laudos', icon: 'mdi-format-list-bulleted' },
        }
      },
      {
        path: 'agendamentos/listar', component: ListLaudosAgendadosComponent,
        data: {
          permissao: 'laudo_visualizar',
          title: 'Listar agendamentos',
          menuItem: { label: 'Listar agendamentos', icon: 'mdi-format-list-bulleted' },
        }
      },
      {
        path: 'configuracao/adicionar', component: FormConfigLaudoUnionComponent,
        data: {
          permissao: 'usuario_analista',
          title: 'Nova configuração',
          // menuItem: { label: "Nova configuração", icon: 'mdi-plus-circle-outline' },
        }
      },
      {
        path: 'configuracao/editar/:uuid', component: FormConfigLaudoUnionComponent,
        data: {
          permissao: 'usuario_analista',
          title: 'Alterar configuração de laudo',
        }
      },
      {
        path: 'configuracao/listar', component: ListConfigLaudoUnionComponent,
        data: {
          permissao: 'usuario_analista',
          title: 'Listar configurações de laudo',
          menuItem: { label: 'Configurações', icon: 'mdi-format-list-bulleted' }
        }
      },
      {
        path: 'agendamento/adicionar', component: FormAgendamentoLaudoUnionComponent,
        data: {
          permissao: 'usuario_analista',
          title: 'Novo agendamento de laudo',
          // menuItem: { label: 'Agendar laudo', icon: 'mdi-calendar-clock' }
        }
      },
      {
        path: 'agendamento/adicionar', component: FormAgendamentoLaudoUnionComponent,
        data: {
          permissao: 'usuario_analista',
          title: 'Novo agendamento de laudo',
          menuItem: { label: 'Novo agendamento', icon: 'mdi-format-list-bulleted' }
        }
      },
    ]
  },

  // laudo carsys
  {
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    path: 'carsys',
    data: { menu: { label: 'Carsys', icon: '' } },
    children: [
      { path: '', redirectTo: 'listar', pathMatch: 'prefix' },
      {
        path: 'upload', component: UploadLaudoComponent,
        data: {
          permissao: 'laudocarsys_visualizar',
          title: 'Carsys - Upload tabela',
          menuItem: { label: "Upload de arquivo", icon: 'mdi-plus-circle-outline' },
        }
      },
      {
        path: 'listar', component: ListLaudoCarsysComponent,
        data: {
          permissao: 'laudocarsys_visualizar',
          title: 'Carsys - Listar laudos carsys',
          menuItem: { label: 'Listar laudos', icon: 'mdi-format-list-bulleted' },
        }
      },
      /*{
        path: 'tipo/listar', component: ListTipoLaudoCarsysComponent,
        data: {
          permissao: 'laudocarsys_visualizar',
          title: 'Carsys - Listar tipos de  laudo',
          menuItem: { label: 'Tipos de laudo', icon: 'mdi-format-list-bulleted' },
        }
      },
      {
        path: 'tipo/adicionar', component: FormTipoLaudoCarsysComponent,
        data: {
          permissao: 'laudocarsys_visualizar',
          title: 'Carsys - Cadastrar tipo de laudo',
          menuItem: { label: 'Tipo de laudo', icon: 'mdi-format-list-bulleted' },
        }
      },
      {
        path: 'tipo/editar/:id', component: FormTipoLaudoCarsysComponent,
        data: {
          permissao: 'laudocarsys_visualizar',
          title: 'Carsys - Editar tipo de laudo',
          menuItem: { label: 'Tipo de laudo', icon: 'mdi-format-list-bulleted' },
        }
      }*/
    ]
  },

  //tabela preco
  {
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    path: 'tabela-preco',
    data: { menu: { label: 'Tabela de preços', icon: '' } },
    children: [
      { path: '', redirectTo: 'listar', pathMatch: 'prefix' },
      {
        path: 'adicionar', component: FormTabelaPrecoComponent,
        data: {
          permissao: 'tabelapreco_visualizar',
          title: 'Consulta - Adicionar tabela de preço',
          // menuItem: { label: 'Consultas', icon: 'mdi-plus-circle-outline' },
        }
      },
      {
        path: 'visualizar/:uuid', component: FormTabelaPrecoComponent,
        data: {
          permissao: 'tabelapreco_visualizar',
          title: 'Consulta - Visualizar tabela de preço',
          desativarInputsEBotoes: true

        }
      },
      {
        path: 'editar/:uuid', component: FormTabelaPrecoComponent,
        data: {
          permissao: 'tabelapreco_visualizar',
          title: 'Consulta - Editar tabela de preço',
        }
      },
      {
        path: 'tabela-padrao', component: FormTabelaPrecoComponent,
        data: {
          permissao: 'administrador',
          title: 'Consulta - tabela de preço padrão',
          padrao: true,
        }
      },
      {
        path: 'listar', component: ListTabelaPrecoComponent,
        data: {
          permissao: 'tabelapreco_visualizar',
          title: 'Consulta - Listar tabela de preços',
          menuItem: { label: 'Tabela de preços (consultas)', icon: 'mdi-format-list-bulleted' },
        }
      },
      {
        path: 'laudo/adicionar', component: FormTabelaPrecoLaudoComponent,
        data: {
          permissao: 'tabelapreco_visualizar',
          title: 'Laudo - Adicionar tabela de preço',
          // menuItem: { label: 'Laudos', icon: 'mdi-plus-circle-outline' },
        }
      },
      {
        path: 'laudo/listar', component: ListTabelaPrecoLaudoComponent,
        data: {
          permissao: 'tabelapreco_visualizar',
          title: 'Laudo - Listar tabela de preços',
          menuItem: { label: 'Tabela de preços (laudos)', icon: 'mdi-format-list-bulleted' },
        }
      },
      {
        path: 'laudo/visualizar/:uuid', component: FormTabelaPrecoLaudoComponent,
        data: {
          permissao: 'tabelapreco_visualizar',
          title: 'Laudo - Visualizar tabela de preço',
          desativarInputsEBotoes: true

        }
      },
      {
        path: 'laudo/editar/:uuid', component: FormTabelaPrecoLaudoComponent,
        data: {
          permissao: 'tabelapreco_visualizar',
          title: 'Laudo - Editar tabela de preço',
        }
      },
      {
        path: 'laudo/tabela-padrao', component: FormTabelaPrecoLaudoComponent,
        data: {
          permissao: 'administrador',
          title: 'Laudo - tabela de preço padrão',
          padrao: true,
        }
      },
    ]
  },
  {
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    path: 'auditoria',
    data: { menu: { label: 'Auditoria', icon: '' } },
    children: [
      { path: '', redirectTo: 'unidades-auditadas', pathMatch: 'prefix' },
      {
        path: 'adicionar-associacao', component: ListNovaAssociacaoAuditoraComponent,
        data: {
          permissao: 'auditoria_associarunidades',
          title: 'Nova associação de auditoria',
          menuItem: { label: 'Nova associação de auditoria', icon: 'mdi-plus-circle-outline' },
        }
      },
      {
        path: 'adicionar-associacao-auditoria', component: ListNovaAssociacaoAuditorComponent,
        data: {
          permissao: 'auditoria_associarusuarios',
          title: 'Nova associação de auditoria',
          menuItem: { label: 'Nova associação de auditoria', icon: 'mdi-plus-circle-outline' },
        }
      },
      {
        path: 'adicionar-associacao-auditoria/:id', component: ListNovaAssociacaoAuditorComponent,
        data: {
          permissao: 'auditoria_associarusuarios',
          title: 'Nova associação de auditoria',
          //menuItem: { label: 'Nova associação de auditoria', icon: 'mdi-plus-circle-outline' },
        }
      },
      {
        path: 'unidades-auditadas', component: ListUnidadesAuditadasComponent,
        data: {
          // permissao: 'auditoria_visualizar',
          permissao: 'auditoria_associarusuarios',
          title: 'Listar unidades auditadas',
          menuItem: { label: 'Unidades auditadas', icon: 'mdi-plus-circle-outline' },
        }
      },
      {
        path: 'laudos-auditados', component: AuditarLaudoAuditoriaComponent,
        data: {
          permissao: 'auditoria_laudos',
          title: 'Auditar laudo',
          menuItem: { label: 'Auditar laudo', icon: 'mdi-plus-circle-outline' },
        }
      },
    ]
  },

  // Route Sistema CIAC
  {
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    path: 'ciac',
    data: { menu: { label: 'Ciac', icon: '' } },
    children: [
      { path: '', redirectTo: 'consultas-ciac', pathMatch: 'prefix' },
      {
        path: 'consultas/listar', component: ListaConsultasCiacComponent,
        data: {
          permissao: 'modulo_ciac',
          title: 'Listar consultas',
          menuItem: { label: 'Listar consultas', icon: 'mdi-format-list-bulleted' },
        }
      },
      {
        path: 'consultas/adicionar', component: FormConsultasCiacComponent,
        data: {
          permissao: 'modulo_ciac',
          title: 'Adicionar consultas',
          // menuItem: { label: 'Adicionar consultas', icon: 'mdi-format-list-bulleted' },
        }
      },
      {
        path: 'consultas/editar/:id', component: FormConsultasCiacComponent,
        data: {
          permissao: 'modulo_ciac',
          title: 'Editar Consulta'
        }
      },
      {
        path: 'consultas/dados-consulta-saida/:id', component: DcsComponent,
        data: {
          permissao: 'modulo_ciac',
          title: 'Dados consultas saída'
        }
      },
      {
        path: 'fornecedores/listar', component: ListaFornecedoresCiacComponent,
        data: {
          permissao: 'modulo_ciac',
          title: 'Listar fornecedores',
          menuItem: { label: 'Listar fornecedores', icon: 'mdi-format-list-bulleted' },
        }
      },
      {
        path: 'fornecedores/adicionar', component: FormFornecedoresCiacComponent,
        data: {
          permissao: 'modulo_ciac',
          title: 'Adicionar fornecedor',
        }
      },
      {
        path: 'fornecedores/editar/:id', component: FormFornecedoresCiacComponent,
        data: {
          permissao: 'modulo_ciac',
          title: 'Editar fornecedor',
        }
      },
      {
        path: 'conversao/listar', component: ListaConversoesComponent,
        data: {
          permissao: 'modulo_ciac',
          title: 'Listar conversões',
          menuItem: { label: 'Listar conversões', icon: 'mdi-format-list-bulleted' },
        }
      },
      {
        path: 'conversao/adicionar', component: FormConversoesComponent,
        data: {
          permissao: 'modulo_ciac',
          title: 'Adicionar conversão',
        }
      },
      {
        path: 'conversao/editar/:id', component: FormConversoesComponent,
        data: {
          permissao: 'modulo_ciac',
          title: 'Editar conversão',
        }
      },
      {
        path: 'consultas-fornecedores/listar', component: ListaConsultasFornecedoresComponent,
        data: {
          permissao: 'modulo_ciac',
          title: 'Listar consultas e fornecedores',
          menuItem: { label: 'Consultas e fornecedores', icon: 'mdi-format-list-bulleted' },
        }
      },
      {
        path: 'consultas-fornecedores/adicionar', component: FormConsultasFornecedoresComponent,
        data: {
          permissao: 'modulo_ciac',
          title: 'Adicionar consultas e fornecedores',
        }
      },
      {
        path: 'consultas-fornecedores/editar/:id', component: FormConsultasFornecedoresComponent,
        data: {
          permissao: 'modulo_ciac',
          title: 'Editar consultas e fornecedores',
        }
      },
      {
        path: 'consultas-fornecedores/dados-consulta-entrada/:id', component: DceComponent,
        data: {
          permissao: 'modulo_ciac',
          title: 'Dados consultas entrada'
        }
      },
      {
        path: 'consulta/resultado/:id', component: ConsultaResultadoCiacComponent,
        data: {
          permissao: 'modulo_ciac',
          title: 'Resultado consulta',
        }
      }
    ]
  },

  // Financeiro Union
  {
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    path: 'faturamento',
    data: { menu: { label: 'Financeiro', icon: '' } },
    children: [

      { path: '', redirectTo: 'lista', pathMatch: 'prefix' },

      {
        path: 'lista',
        component: FaturamentoComponent,
        data: {
          permissao: 'faturamento_matriz',
          title: 'Faturamento',
          menuItem: {
            label: 'Faturamento',
            icon: 'mdi-cash-register'
          }
        },
      },

      {
        path: 'meufaturamento',
        component: MeuFaturamentoComponent,
        data: {
          permissao: 'meu_faturamento',
          title: 'Meu faturamento',
          menuItem: {
            label: 'Meu Faturamento',
            icon: 'mdi-file-eye'
          }
        },
      },

      {
        path: ':idUnidade',
        component: FaturamentoComponent,
        data: { title: 'Lista', menuItem: { label: 'Detalhe da Fatura', icon: '' } },
      },
      {
        path: 'detalhe/:idFaturamento',
        component: FaturamentoDetalhamentoComponent,
        data: { permissao: 'consulta_visualizar', title: 'Detalhe da Fatura' },
      },
      {
        path: 'detalhe/:idFaturamento/cliente/:idCliente',
        component: FaturamentoDetalhamentoClienteComponent,
        data: { permissao: 'consulta_visualizar', title: 'Detalhamento do Cliente' },
      },

    ],
  },

  // Serviços de Venda
  // {
  //   canActivate: [AuthGuardService],
  //   canActivateChild: [AuthGuardService],
  //   path: 'servicos',
  //   data: { menu: { label: 'Serviços', icon: '' } },
  //   children: [

  //     { path: '', redirectTo: 'comunicacao-de-venda', pathMatch: 'prefix' },

  //     {
  //       path: '',
  //       component: ServicosComponent,
  //       data: {
  //         permissao: 'consulta_visualizar',//Essa permissão é de outro componente
  //         title: 'Comunicação de Venda',
  //         menuItem: {
  //           label: 'Comunicação de Venda',
  //           icon: 'mdi-format-list-bulleted'
  //         }
  //       },
  //     },

  //   ],
  // },

  // Erros
  {
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    path: 'error',
    data: { menu: { label: 'Erro', icon: '' } },
    children: [
      { path: '', redirectTo: 'error', pathMatch: 'prefix' },
      {
        path: '401', component: Erro401Component,
        data: {
          permissao: '',
          title: 'Erro 401 - Não Autorizado',
        }
      }
    ]
  },

  { path: 'ws/laudo/relatorioLaudoPdf/:id', redirectTo: 'laudo/visualizar/:id', pathMatch: 'prefix' },
  { path: 'resultadoconsultacliente/:token', redirectTo: 'consulta/resultado-cliente/:token', pathMatch: 'prefix' },
  { path: 'hash/resultadoconsultacliente/:token', redirectTo: 'consulta/resultado-cliente/:token', pathMatch: 'prefix' },
  { path: 'decisaocerta/:token', redirectTo: 'consulta/resultado-cliente/:token', pathMatch: 'prefix' },
  { path: 'hash/decisaocerta/:token', redirectTo: 'consulta/resultado-cliente/:token', pathMatch: 'prefix', },
  { path: '**', component: ErroComponent },

]

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
